<template>
  <div>
    <div class="redis-title">
      <div>{{ $t("RAM.AWS.ElasticCache.redisTitle") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:redisGcp:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:redisGcp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="redis-top">
      <redis-search ref="child"></redis-search>
    </div>
    <table-redis></table-redis>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import RedisSearch from "./RedisSearch";
import TableRedis from "./TableRedis";
import Export from "../Export";

export default {
  name: "Redis",
  components: {
    RedisSearch,
    TableRedis,
    Export
  },
  data() {
    return {
      loading: false,
      modal_loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.child.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 401,
          accountType: 4
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      var exportDTO = {
        accountIdList: this.$refs.child.accountIdList,
        displayName: this.$refs.child.displayName,
        companyId: this.$refs.child.companyId
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportGcpRedis(exportDTO).then(res => {
        let fileName = "Redis.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success("导出成功");
      });
    }
  }
};
</script>

<style scoped>
.redis-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.redis-title > div:nth-child(1) {
  float: left;
}
.redis-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.redis-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/redis/Redis.vue